export const CONSENT_ENDPOINTS = {
    HISTORY: '/consent/history',
    AUDIT_TRAIL: '/consent/auditTrail',
};

export const CONSENT_AUDIT_ERRORS = {
    LOAD_FAILED: 'Failed to load consent history.',
    DOWNLOAD_FAILED: 'Failed to download audit trail.',
};

export const CONSENT_AUDIT_TRAIL_FALLBACK_FILENAME = 'AiCA_Consent_Audit_Trail.pdf';

// No hardcoded go-live month here — a literal month bakes in a launch date the ledger's backend
// owns and silently goes wrong once it passes (or the deferred backfill lands). Keep the copy a
// statement about this org's history, not a claim about when the ledger started writing.
export const CONSENT_PANEL_EMPTY_STATE = 'No consent activity recorded for this organisation yet.';

export const CONSENT_PANEL_LOAD_FAILED = "Couldn't load consent history. Please try again.";
